import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Search from '@components/Search';

import { getUser } from '@services/UserService';

import { handleRequestError } from '@helpers/handleRequestError';

import { Container, Logo } from './styles';

const HomePage = () => {
  const { push } = useHistory();
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const mounted = useRef(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    const { value } = e.target;

    setQuery(value);
  }

  async function handleSearch() {
    if (loading) return;

    try {
      setLoading(true);

      const user = await getUser(query);

      push(`/user/${user.login}`);
    } catch (error) {
      handleRequestError('User not found');
    } finally {
      if (mounted.current) setLoading(false);
    }
  }

  return (
    <Container>
      <Logo>
        <h1>Github Search</h1>
      </Logo>

      <Search
        value={query}
        onChange={handleChange}
        handleSearch={handleSearch}
        loading={loading}
        placeholder="Insert a github username here"
      />
    </Container>
  );
};

export default HomePage;
